import { useEffect, useRef, useState } from "react";
import { useField } from "@unform/core";
import {
  formatCNPJ,
  formatCPF,
  isValidCNPJ,
  isValidCPF
} from "@brazilian-utils/brazilian-utils";

export default function CnpjCpfInput({ name, label, setTypePerson, ...rest }) {
  const [cnpjCpf, setCnpjCpf] = useState();

  const inputRef = useRef(null);

  const { fieldName, registerField, defaultValue, error } = useField(name);

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: inputRef.current,
      path: "value"
    });
  }, [fieldName, registerField]);

  function handleChange(event) {
    if (isValidCNPJ(event.target.value)) {
      setTypePerson("juridic");

      const formattedCnpj = formatCNPJ(event.target.value);

      setCnpjCpf(formattedCnpj);
    } else if (isValidCPF(event.target.value)) {
      setTypePerson("simple");

      const formattedCpf = formatCPF(event.target.value);

      setCnpjCpf(formattedCpf);
    } else {
      setTypePerson(null);

      setCnpjCpf(event.target.value);
    }
  }

  return (
    <>
      <label htmlFor={fieldName}>{label}</label>

      <input
        id={fieldName}
        ref={inputRef}
        defaultValue={defaultValue}
        onChange={handleChange}
        value={cnpjCpf}
        {...rest}
      />

      {error && <span>{error}</span>}
    </>
  );
}
